import BaseSurvey from "./BaseSurvey";
import Variant from "./Variant";

class SurveyWithVariants extends BaseSurvey {
  constructor({
    surveyId = "",
    surveyName = "",
    surveyTitle = "",
    source = "GCS",
    //    selectedProject = '',
    folder = "",
    apiKey = "",
    variantActiveByDefault = false,
    useCaptions = false,
    captionFormat = null,
    captionJsonField = null,
    variantFields = [],
    comparisonScheme = "all_pairs",
    referenceVariantName = null,
    variants = [new Variant()],
    access = [],
    user_role = "",
  } = {}) {
    super({
      surveyId,
      surveyName,
      surveyTitle,
      source,
      folder,
      apiKey,
      variantActiveByDefault,
      useCaptions,
      captionFormat,
      captionJsonField,
      variantFields,
      comparisonScheme,
      referenceVariantName,
    });

    this.variants = variants;
    this.access = access.map((a) => new SurveyAccess(a));
    this.user_role = user_role;
  }

  getSurveyProperties() {
    return {
      surveyId: this.surveyId,
      surveyName: this.surveyName,
      surveyTitle: this.surveyTitle,
      source: this.source,
      //    selectedProject: this.selectedProject,
      folder: this.folder,
      apiKey: this.apiKey,
      variantActiveByDefault: this.variantActiveByDefault,
      useCaptions: this.useCaptions,
      captionFormat: this.captionFormat,
      captionJsonField: this.captionJsonField,
      variantFields: this.variantFields,
      comparisonScheme: this.comparisonScheme,
      referenceVariantName: this.referenceVariantName,
      user_role: this.user_role,
    };
  }

  getAllVariants() {
    return this.variants;
  }

  getAccess() {
    return this.access;
  }

  addAccess(access) {
    this.access.push(new SurveyAccess(access));
  }

  removeAccess(accessId) {
    this.access = this.access.filter((a) => a.accessId !== accessId);
  }
}

class SurveyAccess {
  constructor({ userId = null, email = null, role = "viewer" } = {}) {
    this.accessId = this.generateAccessId();
    this.userId = userId;
    this.email = email;
    this.role = role;
  }

  generateAccessId() {
    return Math.random().toString(36).slice(2, 11);
  }
}

export default SurveyWithVariants;
